import { render } from "./LanguageView.vue?vue&type=template&id=8a431b08&scoped=true"
import script from "./LanguageView.vue?vue&type=script&lang=js"
export * from "./LanguageView.vue?vue&type=script&lang=js"

import "./LanguageView.vue?vue&type=style&index=0&id=8a431b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a431b08"]])

export default __exports__